<template>
    <div class="w-full">
        <div class="flex flex-wrap w-full">
            <div class="w-full sm:w-auto xs:pr-0 xs:pb-1">
                <label for="chart-book" class="leading-loose align-top mr-1 inline-block">
                    <span>Book:</span>
                </label>
                <div class="relative inline-block flex-col w-full sm:w-auto mr-1 xs:mr-0">
                    <select v-model="selectedChartBook" id="chart-book" class="form-control form-control-sm form-control-fixed align-bottom bg-white">
                        <option :value="chartBook" v-for="chartBook in props.chartBooks">{{ chartBook.name }}</option>
                    </select>
                </div>
            </div>
            <div class="w-full sm:w-auto xs:pr-0 xs:pb-1 ml-1 xs:ml-0">
                <label for="chart-record" class="leading-loose align-top mr-1 inline-block">
                    <span>Chart:</span>
                </label>
                <div class="relative inline-block flex-col w-full sm:w-auto mr-1 xs:mr-0">
                    <select v-model="selectedChart" id="chart-record" class="form-control form-control-sm form-control-fixed align-bottom bg-white">
                        <option value="">Select One</option>
                        <option :value="chart" v-for="chart in cCharts">{{ chart.title || chart.symbol_display || chart.symbol }}</option>
                    </select>
                </div>
            </div>
            <div class="md:ml-1 xs:mt-1 xs:mx-auto print:hidden">
                <button :class="{ 'btn-disabled': selectedChart === '' }" class="btn btn-sm btn-yellow" @click="redirectToChart">&nbsp; Draw Chart &nbsp;</button>
            </div>
            <div class="border-t border-gray-400 pt-2 mt-2 md:border-0 md:pt-0 md:mt-0 w-full md:w-auto ml-auto print:hidden">
                <div class="text-center">
                    <button class="btn btn-sm btn-blue" @click="redirectToChartBook">See All Chart Books</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';

const props = defineProps({
    chartBooks: {
        type: Array,
        required: true
    },
    chartBookId: Number,
    chartId: Number,
    jims: Boolean
});

const selectedChartBook = ref(findChartBook() || props.chartBooks[0]);
const selectedChart = ref(findChart() || props.chartBooks[0].charts[0]);

watch(selectedChartBook, () => {
    selectedChart.value = '';
});

const cCharts = computed(() => {
    return selectedChartBook.value.charts;
});

const redirectToChart = () => {
    const route = window.route('my-folder.chart-book.view-chart', {
        chart_book: selectedChart.value.interactive_chart_book_id,
        chart: selectedChart.value.id,
    });
    window.location = route;
};

const redirectToChartBook = () => {
    let route;
    if (props.jims) {
        route = window.route('jims-desk.jims-chartbook');
    } else {
        route = window.route('my-folder.chart-book.index');
    }
    window.location = route;
};

function findChartBook() {
    return props.chartBooks.find((mChart) => mChart.id === props.chartBookId);
}

function findChart() {
    const pChartBook = findChartBook();
    if (pChartBook) {
        return pChartBook.charts.find((mChart) => mChart.id === props.chartId);
    }
}
</script>

